import React, { useEffect, useState } from 'react';
import {
	Container,
	Grid,
	Header,
	Form,
	Input,
	Dropdown,
	Button,
	Table,
	Modal,
	Segment,
} from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import MainMenu from './Menu';
import { firestore, auth } from '../firebase/index';
import Password from './Password';

function Profile() {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(true);
	const [details, setDetails] = useState(null);
	const [users, setUsers] = useState(null);
	const [error, setError] = useState(null);
	const [open, setOpen] = useState(false);
	const [remove, setRemove] = useState(null);
	const [removeErr, setRemoveErr] = useState(null);
	const [update, setUpdate] = useState(null);
	const [updateErr, setUpdateErr] = useState(null);
	const [success, setSuccess] = useState(false);

	useEffect(() => {
		if (user) {
			firestore
				.collection('users')
				.where('uid', '==', user.uid)
				.get()
				.then((snapshot) => {
					snapshot.forEach((doc) => {
						const object = doc.data();
						object.doc = doc.id;
						setDetails(object);
						setLoading(false);
					});
				});

			fetch('/firebase/users', {
				method: 'GET',
				headers: new Headers({
					'Content-Type': 'application/json',
				}),
			})
				.then((response) => {
					if (response.status === 401 || response.status === 403) {
						// * Handle 401 or 403 error by fetching a new token
						return fetch('/firebase/token', {
							method: 'POST',
							body: JSON.stringify({
								userId: auth.currentUser.uid
							}),
							headers: new Headers({
								'Content-Type': 'application/json',
								'x-api-key': process.env.REACT_APP_API_KEY
							})
						})
							.then((tokenResponse) => tokenResponse.json())
							.then(() => {
								// * Retry the original request with the new token
								return fetch('/firebase/users', {
									method: 'GET',
									headers: new Headers({
										'Content-Type': 'application/json'
									})
								});
							});
					}
					return response;
				})
				.then(response => response.json())
				.then((json) => {
					console.log('json', json);
					setUsers(json.users);
				})
				.catch((err) => console.log(err));
		}
	}, [user, open, remove, update]);

	const deleteUser = (uid) => {
		fetch('/firebase/delete', {
			method: 'POST',
			body: JSON.stringify({
				uid,
			}),
			headers: new Headers({
				'Content-Type': 'application/json',
			}),
		})
			.then((response) => {
				if (response.status === 401 || response.status === 403) {
					// * Handle 401 or 403 error by fetching a new token
					return fetch('/firebase/token', {
						method: 'POST',
						body: JSON.stringify({
							userId: auth.currentUser.uid
						}),
						headers: new Headers({
							'Content-Type': 'application/json',
							'x-api-key': process.env.REACT_APP_API_KEY
						})
					})
						.then((tokenResponse) => tokenResponse.json())
						.then(() => {
							// * Retry the original request with the new token
							return fetch('/firebase/delete', {
								method: 'POST',
								body: JSON.stringify({
									uid,
								}),
								headers: new Headers({
									'Content-Type': 'application/json',
								}),
							});
						});
				}
				return response;
			})
			.then(response => response.json())
			.then((json) => {
				if (json.error) {
					setRemoveErr(json.error);
				} else {
					setRemove(null);
					setRemoveErr(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const updateUser = (uid) => {
		//console.log(uid);
		firestore
			.collection('users')
			.where('uid', '==', uid)
			.get()
			.then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					const data = doc.data();
					data.doc = doc.id;
					setUpdate(data);
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};

	return (
		<>
			<MainMenu />
			{loading && (
				<Container text className="mb-40 mt-40">
					<Grid stackable>
						<Grid.Row columns={1}>
							<Grid.Column>
								<p className="quiet" style={{ textAlign: 'center' }}>
									Autenticando al usuario...
								</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			)}
			{!loading && details.role !== 'Administrador' && (
				<Container text className="mb-40 mt-40">
					<Grid stackable>
						<Grid.Row columns={1}>
							<Grid.Column>
								<p className="quiet" style={{ textAlign: 'center' }}>
									Lo sentimos, su cuenta no tiene privilegios para ver esta
									sección
								</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			)}
			{users && (
				<Container text className="mt-40">
					<Grid stackable>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Header as="h1">Perfil del Usuario</Header>
								<div className="small">
									Nombre: {details && details.name}{' '}
									{details && details.lastName}
								</div>
								<div className="small">
									Correo Electrónico: {details && details.email}
								</div>
								<div className="small">
									Teléfono: {details && details.phone}
								</div>
								<div className="small">
									Entidad: {details && details.entity}
								</div>
								<div className="small">
									Privilegio: {details && details.role}
								</div>
								<div className="mt-10">
									<Button
										color="green"
										content="Editar Perfil"
										icon="user"
										size="small"
										onClick={() => updateUser(user.uid)}
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Header as="h3">
									Modificar Contraseña
									<Header.Subheader>
										Utilice el siguiente formulario para modificar su
										contraseña.
									</Header.Subheader>
								</Header>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Segment>
									<Password />
								</Segment>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			)}
			{users && details && details.role === 'Administrador' && (
				<Container text className="mb-40 mt-10">
					<Modal
						open={!!update}
						size="tiny"
						closeIcon
						onClose={() => setUpdate(null)}
					>
						<Modal.Header>Modificar usuario</Modal.Header>
						<Modal.Content>
							<Formik
								initialValues={{
									email: update ? update.email : '',
									password: update ? update.password : '',
									name: update ? update.name : '',
									lastName: update ? update.lastName : '',
									entity: update ? update.entity : '',
									phone: update ? update.phone : '',
									role: update ? update.role : '',
								}}
								validationSchema={Yup.object().shape({
									email: Yup.string().email('Correo electrónico no valido'),
								})}
								onSubmit={(values, { setSubmitting }) => {
									const object = {};

									_.forEach(values, (val, key) => {
										if (val) {
											object[key] = val;
										}
									});

									const object2 = object;
									object2.uid = update.uid;
									fetch('/firebase/update', {
										method: 'POST',
										body: JSON.stringify(object2),
										headers: new Headers({
											'Content-Type': 'application/json',
										}),
									})
										.then((response) => {
											if (response.status === 401 || response.status === 403) {
												// * Handle 401 or 403 error by fetching a new token
												return fetch('/firebase/token', {
													method: 'POST',
													body: JSON.stringify({
														userId: auth.currentUser.uid
													}),
													headers: new Headers({
														'Content-Type': 'application/json',
														'x-api-key': process.env.REACT_APP_API_KEY
													})
												})
													.then((tokenResponse) => tokenResponse.json())
													.then(() => {
														// * Retry the original request with the new token
														return fetch('/firebase/update', {
															method: 'POST',
															body: JSON.stringify(object2),
															headers: new Headers({
																'Content-Type': 'application/json',
															}),
														});
													});
											}
											return response;
										})
										.then(response => response.json())
										.then((json) => {
											if (json.error) {
												setUpdateErr(json.error);
												setSubmitting(false);
											} else {
												firestore
													.collection('users')
													.doc(update.doc)
													.update(object)
													.then(() => {
														setSubmitting(false);
														setUpdateErr(false);
														setUpdate(null);
													})
													.catch((err) => {
														setUpdateErr(err);
														setSubmitting(false);
													});
											}
										})
										.catch((err) => {
											console.log(err);
											setSubmitting(false);
										});
								}}
							>
								{({
									values,
									errors,
									handleChange,
									handleBlur,
									handleSubmit,
									isSubmitting,
									touched,
									setFieldValue,
									setFieldTouched,
								}) => {
									return (
										<Form
											onSubmit={handleSubmit}
											size="tiny"
											className="event-form"
											noValidate
										>
											<Form.Group widths="equal">
												<Form.Field
													name="email"
													type="email"
													label="Correo electrónico"
													value={values.email}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={errors.email && touched.email && errors.email}
												/>
												<Form.Field
													name="password"
													type="password"
													label="Contraseña (Mas de 6 caracteres)"
													value={values.password}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Field
													name="name"
													label="Nombre"
													value={values.name}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
												/>
												<Form.Field
													name="lastName"
													label="Apellidos"
													value={values.lastName}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Field
													name="phone"
													type="tel"
													label="Teléfono (Formato: 7875555555)"
													placeholder="7875555555"
													value={values.phone}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
												/>
												<Form.Field
													name="entity"
													label="Entidad"
													value={values.entity}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
												/>
											</Form.Group>
											{update.role === 'Administrador' && (
												<Form.Group widths="equal">
													<Form.Field
														label="Privilegios"
														name="role"
														selection
														onChange={(e, { value }) => {
															setFieldValue('role', value);
														}}
														onBlur={() => {
															setFieldTouched('role');
														}}
														value={values.role}
														control={Dropdown}
														options={[
															{
																key: 'Editor',
																text: 'Editor',
																value: 'Editor',
															},
															{
																key: 'Administrador',
																text: 'Administrador',
																value: 'Administrador',
															},
														]}
													/>
												</Form.Group>
											)}
											<Form.Group widths="equal">
												<Form.Button
													type="submit"
													size="mini"
													color="orange"
													loading={isSubmitting}
													disabled={isSubmitting}
													content="Enviar"
												/>
											</Form.Group>
										</Form>
									);
								}}
							</Formik>
							{updateErr && (
								<p
									className="quiet mt-10 mb-10"
									style={{ textAlign: 'center' }}
								>
									Los sentimos, hubo un error en la creación del usuario. (
									{updateErr.code} - {updateErr.message})
								</p>
							)}
							{success && (
								<p
									className="quiet mt-10 mb-10"
									style={{ textAlign: 'center' }}
								>
									El usuario ha sido creado exitosamente
								</p>
							)}
						</Modal.Content>
						<Modal.Actions>
							<Button
								size="tiny"
								onClick={() => {
									setUpdate(null);
									setUpdateErr(null);
								}}
							>
								Cancelar
							</Button>
						</Modal.Actions>
					</Modal>
					<Modal
						open={!!remove}
						size="tiny"
						closeIcon
						onClose={() => setRemove(null)}
					>
						<Modal.Header>Eliminar Usuario</Modal.Header>
						<Modal.Content>
							<p>
								¿Está seguro que desea eliminar el usuario{' '}
								<span className="txt-bold">{remove && remove.displayName}</span>{' '}
								con el correo electrónico
								{remove && remove.email}?
							</p>
							{removeErr && (
								<p
									className="quiet mt-10 mb-10"
									style={{ textAlign: 'center' }}
								>
									Los sentimos, hubo un error al eliminar el usuario. (
									{removeErr.code} - {removeErr.message})
								</p>
							)}
						</Modal.Content>
						<Modal.Actions>
							<Button size="tiny" onClick={() => setRemove(null)}>
								Cancelar
							</Button>
							<Button size="tiny" onClick={() => deleteUser(remove.uid)}>
								Eliminar
							</Button>
						</Modal.Actions>
					</Modal>
					<Modal
						open={open}
						size="tiny"
						closeIcon
						onClose={() => setOpen(false)}
					>
						<Modal.Header>Añadir nuevo usuario</Modal.Header>
						<Modal.Content>
							<Formik
								initialValues={{
									email: '',
									password: '',
									name: '',
									lastName: '',
									entity: '',
									phone: '',
									role: '',
								}}
								validationSchema={Yup.object().shape({
									email: Yup.string()
										.email('Correo electrónico no valido')
										.required('Requerido'),
									password: Yup.string().required('Requerido'),
									name: Yup.string().required('Requerido'),
									lastName: Yup.string().required('Requerido'),
									entity: Yup.string().required('Requerido'),
									phone: Yup.string().required('Requerido'),
									role: Yup.string().required('Requerido'),
								})}
								onSubmit={(values, { setSubmitting, resetForm }) => {
									fetch('/firebase/create', {
										method: 'POST',
										body: JSON.stringify({
											email: values.email,
											phoneNumber: values.phone,
											password: values.password,
											displayName: `${values.name} ${values.lastName}`,
										}),
										headers: new Headers({
											'Content-Type': 'application/json',
										}),
									})
										.then((response) => {
											if (response.status === 401 || response.status === 403) {
												// * Handle 401 or 403 error by fetching a new token
												return fetch('/firebase/token', {
													method: 'POST',
													body: JSON.stringify({
														userId: auth.currentUser.uid
													}),
													headers: new Headers({
														'Content-Type': 'application/json',
														'x-api-key': process.env.REACT_APP_API_KEY
													})
												})
													.then((tokenResponse) => tokenResponse.json())
													.then(() => {
														// * Retry the original request with the new token
														return fetch('/firebase/create', {
															method: 'POST',
															body: JSON.stringify({
																email: values.email,
																phoneNumber: values.phone,
																password: values.password,
																displayName: `${values.name} ${values.lastName}`,
															}),
															headers: new Headers({
																'Content-Type': 'application/json',
															}),
														});
													});
											}
											return response;
										})
										.then(response => response.json())
										.then((json) => {
											if (json.error) {
												setSuccess(false);
												setError(json.error);
												setSubmitting(false);
											} else {
												firestore
													.collection('users')
													.add({
														email: values.email,
														password: values.password,
														name: values.name,
														lastName: values.lastName,
														entity: values.entity,
														phone: values.phone,
														role: values.role,
														uid: json.uid,
													})
													.then(() => {
														setSuccess(true);
														setSubmitting(false);
														setError(null);
														resetForm();
													})
													.catch((err) => {
														setSuccess(false);
														setError(err.message);
														setSubmitting(false);
													});
											}
										})
										.catch((err) => {
											setSuccess(false);
											setError(err.message);
											setSubmitting(false);
										});
								}}
							>
								{({
									values,
									errors,
									handleChange,
									handleBlur,
									handleSubmit,
									isSubmitting,
									touched,
									setFieldValue,
									setFieldTouched,
								}) => {
									return (
										<Form
											onSubmit={handleSubmit}
											size="tiny"
											className="event-form"
											noValidate
										>
											<Form.Group widths="equal">
												<Form.Field
													required
													name="email"
													type="email"
													label="Correo electrónico"
													value={values.email}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={errors.email && touched.email && errors.email}
												/>
												<Form.Field
													required
													name="password"
													type="password"
													label="Contraseña (Mas de 6 caracteres)"
													value={values.password}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={
														errors.password &&
														touched.password &&
														errors.password
													}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Field
													required
													name="name"
													label="Nombre"
													value={values.name}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={errors.name && touched.name && errors.name}
												/>
												<Form.Field
													required
													name="lastName"
													label="Apellidos"
													value={values.lastName}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={
														errors.lastName &&
														touched.lastName &&
														errors.lastName
													}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Field
													required
													name="phone"
													type="tel"
													label="Teléfono (Formato: 7875555555)"
													placeholder="7875555555"
													value={values.phone}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={errors.phone && touched.phone && errors.phone}
												/>
												<Form.Field
													required
													name="entity"
													label="Entidad"
													value={values.entity}
													onChange={handleChange}
													onBlur={handleBlur}
													control={Input}
													error={
														errors.entity && touched.entity && errors.entity
													}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Field
													label="Privilegios"
													name="role"
													selection
													required
													onChange={(e, { value }) => {
														setFieldValue('role', value);
													}}
													onBlur={() => {
														setFieldTouched('role');
													}}
													value={values.role}
													control={Dropdown}
													options={[
														{
															key: 'Editor',
															text: 'Editor',
															value: 'Editor',
														},
														{
															key: 'Administrador',
															text: 'Administrador',
															value: 'Administrador',
														},
													]}
													error={errors.role && touched.role && errors.role}
												/>
											</Form.Group>
											<Form.Group widths="equal">
												<Form.Button
													type="submit"
													size="mini"
													color="orange"
													loading={isSubmitting}
													disabled={isSubmitting}
													content="Enviar"
												/>
											</Form.Group>
										</Form>
									);
								}}
							</Formik>
							{error && (
								<p
									className="quiet mt-10 mb-10"
									style={{ textAlign: 'center' }}
								>
									Los sentimos, hubo un error en la creación del usuario. (
									{error.code} - {error.message})
								</p>
							)}
							{success && (
								<p
									className="quiet mt-10 mb-10"
									style={{ textAlign: 'center' }}
								>
									El usuario ha sido creado exitosamente
								</p>
							)}
						</Modal.Content>
						<Modal.Actions>
							<Button size="tiny" onClick={() => setOpen(false)}>
								Cancelar
							</Button>
						</Modal.Actions>
					</Modal>
					<Grid stackable>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Header as="h3">
									Consola de Administración
									<Header.Subheader>
										En esta sección podras administrar los usuarios de esta
										aplicación. Aquí podras añadir usuarios, borrar usuarios o
										editar los detalles de los usuarios existentes.
									</Header.Subheader>
								</Header>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Button
									content="Añadir Usuario"
									icon="add user"
									size="small"
									onClick={() => setOpen(true)}
								/>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								{users && (
									<Table
										striped
										size="small"
										className="small"
										definition
										singleLine
									>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell className="small">
													Correo electrónico
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Nombre
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Teléfono
												</Table.HeaderCell>
												<Table.HeaderCell />
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{_.map(users, (u) => {
												return (
													<Table.Row key={u.uid} className="small">
														<Table.Cell>{u.email}</Table.Cell>
														<Table.Cell textAlign="center">
															{u.displayName}
														</Table.Cell>
														<Table.Cell textAlign="center">
															{u.phoneNumber}
														</Table.Cell>
														<Table.Cell textAlign="center">
															<Button
																size="mini"
																icon="close"
																onClick={() => setRemove(u)}
															/>
															<Button
																size="mini"
																icon="pencil"
																onClick={() => updateUser(u.uid)}
															/>
														</Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								)}
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			)}
		</>
	);
}

export default Profile;
